import { Form } from "react-bootstrap";

const DateTimeField = ({ formik, formClass, label, valueName, style, showErrors = true }) => {
  const error = formik?.errors?.[valueName];
  // Show the error once the field was touched or a submit was attempted.
  const visible = Boolean(error) && (formik?.touched?.[valueName] || formik?.submitCount > 0);
  return (
    <Form.Group
      className={formClass ? formClass : "form-inline"}
      controlId={valueName}
      style={style}
    >
      <Form.Label>{label}:</Form.Label>
      <Form.Control
        type="datetime-local"
        name={valueName}
        placeholder={label}
        value={formik.values[valueName] ?? ""}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        isInvalid={visible}
        style={{ width: "100%" }}
      />
      {showErrors && visible ? (
        <div className="invalid-feedback d-block">{error}</div>
      ) : null}
    </Form.Group>
  );
};

export default DateTimeField;
